import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UsuariosService } from '../../services/usuarios.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm:FormGroup;
  recoveryPassword:boolean=false
  errorLogin:boolean=false
  esRecienCreado:boolean=false
  msgErrorLogin:string=""
  msgErrorPass:string=""
  tempToken:any=""
  constructor(
    public formBuilder: FormBuilder,
    private router:Router,
    private usuariosService:UsuariosService) { }

  ngOnInit() {
    this.loginForm=this.formBuilder.group({
      login:['', Validators.required],
      password:['', Validators.required],
     })
  }

  validatelogin(){
    let dataValidate:any={}

    if (this.loginForm.dirty && this.loginForm.valid) {
      dataValidate={
        login:this.loginForm.value.login,
        password:this.loginForm.value.password,
      }
      
      this.errorLogin=false
      this.msgErrorLogin=""
      this.usuariosService.loginUsuario(dataValidate).subscribe((data:any)=>{
        if(data.msg!="ok"){
          this.errorLogin=true
          this.msgErrorLogin=data.msg
          
        }else{
          if(data.user.recien_creado){
            this.esRecienCreado=data.user.recien_creado
            sessionStorage.removeItem('token')
            sessionStorage.setItem("token",data.token)
            this.tempToken=data.token
          }else{

            sessionStorage.setItem("token",data.token)
            sessionStorage.setItem("nombre",data.user.nombre)
            sessionStorage.setItem("perfil",data.user.perfil.nombre_perfil)
            this.router.navigate(['lista-clientes-negociacion'], { })
          }
          
          //
        }
      })
    }
    
    
   // this.router.navigate(['inicio'], { });
  }

  openRecoveryP(){
    this.recoveryPassword=true
  }

  closeRecoveryP(){
    this.recoveryPassword=false
    this.errorLogin=false;
  }

  validateUserEmail(){
    
  }

  updateUser(){
    let password_nuevo:any=document.querySelector("#password_nuevo")
    let password_nuevo_validacion:any=document.querySelector("#password_nuevo_validacion")
    this.msgErrorPass=""

   
    if(password_nuevo.value=="" || password_nuevo_validacion.value==""){
      this.msgErrorPass="Contraseñas no pueden estar vacias"
     return false
    }

    
    if(password_nuevo.value!=password_nuevo_validacion.value){
      this.msgErrorPass="Contraseñas nuevas no coinciden"
      return false
    }

    let dataUpdate:any={
      password_nuevo:password_nuevo.value
    }

    let headers = new Headers();
    headers.append('x-token', `${this.tempToken}`);
    let options:any = { headers: headers };

    this.usuariosService.updateUsuario(dataUpdate,options).subscribe((data:any)=>{
      //console.log(data)
      this.esRecienCreado=false
    })
  }

}
